<template>
  <AdminConfirmModal
    v-model="getTestThreeModal"
    :confirm-text="$t('Default.change')"
    confirm-color="sub white--text"
    cancel-color="main_color white--text"
    @confirm="changePrice"
  >
    <label class="mb-4 font-18px black--text text-center d-block">
      {{ $t("Test.cost_test") }}
    </label>
    <v-text-field
      solo
      outlined
      flat
      class="focus-input mb-5"
      hide-details="false"
      height="44px"
      v-model="payload.test_three_price"
    ></v-text-field>
  </AdminConfirmModal>
</template>
<script>
import { ref, watch } from "@vue/composition-api";
import { shortComputed } from "@/utility/helpers";
import {
  DispatchTypes,
  MutationTypes,
  GettersTypes,
} from "@/store/modules/tests/types";
import { useStore } from "vuex-composition-helpers";
import AdminConfirmModal from "@/components/partials/Admin/AdminConfirmModal.vue";

export default {
  components: { AdminConfirmModal },
  setup() {
    const store = useStore();

    const getTestThreeModal = shortComputed(
      {
        storeType: "tests",
        key: "getTestThreeModal",
      },
      MutationTypes.setTestThreeModal
    );

    const payload = ref({
      test_one_price: Number,
      test_three_price: Number,
    });

    const Tracking = watch(
      () => store.getters[GettersTypes.callTariffTest],
      (val) => {
        payload.value.test_one_price = val.test_one_price;
        payload.value.test_three_price = val.test_three_price;
      }
    );

    const changePrice = () => {
      store.dispatch(DispatchTypes.postTariffTest, payload.value).then(() => {
        store.commit(MutationTypes.setTestThreeModal, false);
      });
    };

    return {
      store,
      getTestThreeModal,
      payload,
      changePrice,
      Tracking,
    };
  },
};
</script>
